import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { UserService } from 'services';

export const ChangeEmailPage = () => {
	const [searchParams] = useSearchParams();
	const email = searchParams.get('email');
	const newEmail = searchParams.get('newEmail');
	const token = searchParams.get('token');
	useEffect(() => {
		if (!email || !newEmail || !token) {
			return;
		}
		UserService.changeEmail(email, newEmail, token);
	}, [email, newEmail, token]);
};